var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "criteres" },
    [
      _vm._l(_vm.selection, function(tag, index) {
        return _c(
          "a",
          {
            staticClass: "critere",
            attrs: { href: "" },
            on: {
              click: function($event) {
                $event.preventDefault()
                _vm.deselect(tag)
              }
            }
          },
          [_vm._v(_vm._s(tag.label))]
        )
      }),
      _vm._v(" "),
      _vm.selection.length > 0
        ? _c(
            "a",
            {
              staticClass: "delete",
              attrs: { href: "" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  _vm.reset()
                }
              }
            },
            [_vm._v("Effacer tous les filtres")]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cddba9b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cddba9b6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/SiteBundle/Resources/assets/components/FilterTags.vue
// module id = 502
// module chunks = 1